/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import * as GlobalMessageActions from './global-message-group.actions';
export { GlobalMessageActions };
